import { render, staticRenderFns } from "./page-animation.vue?vue&type=template&id=4a7ee050&scoped=true&"
import script from "./page-animation.vue?vue&type=script&lang=ts&"
export * from "./page-animation.vue?vue&type=script&lang=ts&"
import style0 from "./page-animation.vue?vue&type=style&index=0&id=4a7ee050&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7ee050",
  null
  
)

export default component.exports